export default {
  addNewLookupModal: {
    title: 'Create a new lookup',
    fileNameInput: {
      label: 'What would you like to call this lookup?',
      placeholder: 'File name',
    },
  },
  headerBar: {
    title: 'File Lookups',
    searchInput: {
      placeholder: 'Search for file lookup',
    },
    getLookupResultPopover: {
      title: 'Get Lookup Result',
      lookupFileSelect: {
        label: 'Choose lookup/file to test',
        value: 'Loading file lookups...',
      },
      lookupColumnSelect: {
        label: 'Choose a column to test',
        value: 'Loading file columns...',
      },
      searchInput: {
        label: 'Enter the value to lookup',
        placeholder: 'Search...',
      },
      results: {
        total: '{{ resultCount }} Results',
        row: 'Row {{ rowNumber }}: {{ item }}',
        more: 'Plus {{ moreResultsCount }} more results',
      },
    },
  },
  lookupsTable: {
    table: {
      headers: {
        name: 'Name',
        info: 'Info',
        lastEdited: 'Last Edited',
      },
      data: {
        singleRow: '{{ rowCount }} Row',
        multipleRows: '{{ rowCount }} Rows',
      },
    },
    lookupActions: {
      popover: {
        rename: {
          label: 'Rename',
        },
        viewRows: {
          label: 'View Rows',
        },
      },
      confirmationModal: {
        title: 'Are you sure you want to delete File Lookup {{ displayName }}',
        buttonText: 'Delete',
        alert: {
          body: 'This action cannot be reversed',
        },
      },
    },
    tile: {
      data: {
        singleRow: '{{ rowCount }} Row',
        multipleRows: '{{ rowCount }} Rows',
        lastEditedAt: 'Last edited at {{ dateTime }}',
      },
    },
  },
  renameLookupModal: {
    title: 'Rename file lookup',
    currentNameInput: {
      label: 'Current Name',
    },
    newNameInput: {
      label: 'New Name',
    },
  },
  viewLookupRowsModal: {
    title: 'Rows for {{ name }}',
    titleNameFallback: 'this file lookup',
    controls: {
      showingRowsOfResults:
        'Showing {{ tableRowsCount }} rows of {{ resultCount }} results',
      loadMoreRowsButton: 'Load 50 more rows',
    },
  },
};
